import React from "react";
import { useDatadogGcp } from "@/hooks/useDatadogGcp";
import GCPReportsTemplate from "@/components/templates/GCPReportsTemplate";
import DatadogGcpDashboard from "@/components/organisms/DatadogGcpDashboard";

function DatadogGCPReports() {
  const { embedUrl, loading, error, refetch } = useDatadogGcp();

  return (
    <GCPReportsTemplate
      title="Datadog GCP Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <DatadogGcpDashboard/>
    </GCPReportsTemplate>
  );
}

export default DatadogGCPReports;